import { useEffect, useState } from 'react'

import { FeatureFlagKeys, useIsFeatureFlagEnabled } from './useFeatureFlag'
import { useColorSchemeStore } from '_stores/color-scheme.store'
import { PREFERS_DARK_QUERY, resolveColorMode } from '_utils/color-mode.utils'

const readPrefersDark = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PREFERS_DARK_QUERY).matches
    : false

const usePrefersDark = () => {
  const [prefersDark, setPrefersDark] = useState(readPrefersDark)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return undefined
    }
    const query = window.matchMedia(PREFERS_DARK_QUERY)
    const handleChange = (event: MediaQueryListEvent) => setPrefersDark(event.matches)
    query.addEventListener('change', handleChange)
    return () => query.removeEventListener('change', handleChange)
  }, [])

  return prefersDark
}

export const useIsDarkModeEnabled = () => useIsFeatureFlagEnabled(FeatureFlagKeys.CoreDarkMode)

export const useColorMode = () => {
  const isDarkModeEnabled = useIsDarkModeEnabled()
  const preference = useColorSchemeStore((state) => state.preference)
  const isLightForced = useColorSchemeStore((state) => state.isLightForced)
  const prefersDark = usePrefersDark()

  return resolveColorMode({ isDarkModeEnabled, isLightForced, preference, prefersDark })
}
